{
  "$id": "http://softball.app/schemas/account-private",
  "title": "Account - Private",
  "description": "Account info that should never be sent to the frontend/browser/client",
  "type": "object",
  "required": ["passwordHash", "passwordTokenHash", "passwordTokenExpiration"],
  "properties": {
    "passwordHash": {
      "type": "string",
      "description": "Account password hash"
    },
    "passwordTokenHash": {
      "type": "string",
      "description": "Token used for email confirmation and/or password reset"
    },
    "passwordTokenExpiration": {
      "type": "integer",
      "description": "When the passwordTokenHash expires and can no longer be sed to reset email or validate email address"
    }
  }
}
